import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {Transient} from '../core/entity/core.entity.transient';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {FlowEntity} from './flow.entity';
import {SystemEntity} from './system.entity';
import {EnvironmentKind} from "../enum/environment.kind";

@EntityTable('flow_schedule', 'f2a94e52-a50a-4cf5-adf2-8834559d7943')
export class FlowScheduleEntity extends Entity {

    @Column(FieldTypeKind.STRING)
    public cron: string;

    @JoinColumn(FieldTypeKind.GUID, FlowEntity, false, false, FieldRelationKind.BELONGS_TO, 'process', 'aliasId', 'flowId')
    public flowId: string;

    @JoinColumn(FieldTypeKind.GUID, SystemEntity, true, false, FieldRelationKind.BELONGS_TO, 'system')
    public systemId: string;

    @Column(FieldTypeKind.STRING)
    public queue: string;

    @Column(FieldTypeKind.ANY)
    public args: any;

    @Column(FieldTypeKind.ANY)
    public options: any;

    @Column(FieldTypeKind.BOOLEAN)
    public locked: boolean;

    @Column(FieldTypeKind.GUID)
    public lockedBy: string;

    @Column(FieldTypeKind.LONG)
    public lockedDelay: number;

    @Column(FieldTypeKind.DATE)
    public lockedAt: Date;

    @Column(FieldTypeKind.DATE)
    public lockedUntil: Date;

    @Column(FieldTypeKind.ANY)
    public cronFields: any;

    @Transient()
    public flow: FlowEntity;

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;

}
